/**
 * Canonical duration bounds for break-request pickers. Centralized in the
 * shared widget package so every surface that picks a break length — the web
 * tester apply form, the admin Add-a-break card, the admin Counter modal, and
 * the Discord-Activity custom-window composer — reads one source of truth.
 * Bump the cap or step here and every picker updates in lockstep.
 */
export const DURATION_MIN_MINUTES = 15;
export const DURATION_MAX_MINUTES = 120;
export const DURATION_STEP_MINUTES = 15;

/** Every selectable duration between the min and max, inclusive, in steps. */
export const DURATION_OPTIONS: readonly number[] = Array.from(
  { length: (DURATION_MAX_MINUTES - DURATION_MIN_MINUTES) / DURATION_STEP_MINUTES + 1 },
  (_, i) => DURATION_MIN_MINUTES + i * DURATION_STEP_MINUTES,
);

/**
 * Snaps an arbitrary minute count (e.g. derived from an existing window when
 * seeding a counter-offer) to the nearest selectable step, then clamps it into
 * the `[min, max]` band so a seeded picker always lands on a valid option.
 */
export function clampBreakDuration(minutes: number): number {
  const snapped = Math.round(minutes / DURATION_STEP_MINUTES) * DURATION_STEP_MINUTES;
  return Math.min(DURATION_MAX_MINUTES, Math.max(DURATION_MIN_MINUTES, snapped));
}
